module.exports = __webpack_public_path__ + "static/img/news1_img.47f545a.png";